// import { IS_SP } from '../const/config';

export class FilterInterview {
  constructor() {
    this.DOM = {};
    this.DOM.filterButtons = document.querySelectorAll('[data-filter-buttons]');
    this.DOM.interviewItems = document.querySelectorAll('[data-filter-item]');
    this.DOM.interviewList = document.querySelector('[data-filter-list]') || document.querySelector('.js-interview-list');

    this.CHECKED_CLASS = 'is-checked';
    this.ATTRIBUTE_JOB = 'data-job-term';
    this.ATTRIBUTE_TAG = 'data-tag-term';

    if (this.DOM.filterButtons.length === 0) return;

    this.isAnimating = false;
    this.init();
  }

  /**
   * 1. 初期化・イベントリスナーの登録
   */
  init() {
    this.DOM.filterButtons.forEach((button) => {
      button.addEventListener('click', (e) => this.handleButtonClick(e.currentTarget));
    });
    // ページロード時のURLクエリパラメータ（?jobs=xxx）判定と初期表示の適用
    this.applyInitialUrlFilter();
  }
  /**
   * URLパラメータ（?jobs=sales）を取得して初期絞り込みを適用
   */
  applyInitialUrlFilter() {
    // 1. URLから ?jobs=xxx の値を取得
    const urlParams = new URLSearchParams(window.location.search);
    const targetJobSlug = urlParams.get('job');

    // パラメータが無い（?jobs がついていない）場合は何もしない（全件表示）
    if (!targetJobSlug) return;

    // 2. 該当する job スラッグを持ち、かつ「すべて(all)」であるボタンを探す
    const targetButton = Array.from(this.DOM.filterButtons).find((btn) => {
      const job = btn.getAttribute(this.ATTRIBUTE_JOB);
      const tag = btn.getAttribute(this.ATTRIBUTE_TAG);
      return job === targetJobSlug && tag === 'all';
    });

    // 3. 該当するボタンが存在する場合、is-checked を付与して初期絞り込みを実行
    if (targetButton) {
      targetButton.classList.add(this.CHECKED_CLASS);
      
      // アニメーションなしで即座に絞り込み結果を表示
      const activeConditions = this.getActiveConditions();
      this.filterItems(activeConditions);
    }
  }
  /**
   * 2. ボタンクリック時のメインハンドラー（全体の流れを制御）
   */
  handleButtonClick(currentBtn) {
    if (this.isAnimating) return;

    // ボタンの選択状態（is-checked）を更新
    this.toggleButtonState(currentBtn);

    // 現在選択されている全条件を収集
    const activeConditions = this.getActiveConditions();

    // アニメーション付きで記事を絞り込み表示
    this.applyFilterWithAnimation(activeConditions);
  }
/**
   * 3. ボタンのトグル（ON/OFF）選択処理
   */
  toggleButtonState(currentBtn) {
    const currentTag = currentBtn.getAttribute(this.ATTRIBUTE_TAG);
    const groupJob = currentBtn.getAttribute(this.ATTRIBUTE_JOB);

    if (currentTag === 'all') {
      // 「すべて」ボタン：押されたボタン自体の ON/OFF をトグル
      const wasChecked = currentBtn.classList.contains(this.CHECKED_CLASS);

      // 同グループ内の全ボタンの選択を一度解除
      this.DOM.filterButtons.forEach((b) => {
        if (b.getAttribute(this.ATTRIBUTE_JOB) === groupJob) {
          b.classList.remove(this.CHECKED_CLASS);
        }
      });

      // 1回目(未選択だった)なら ON にし、2回目(選択済みだった)なら OFF（何もつかない状態）にする
      if (!wasChecked) {
        currentBtn.classList.add(this.CHECKED_CLASS);
      }
    } else {
      // 通常タグ：ON/OFF切り替え ＆ 同グループの「すべて」を解除
      currentBtn.classList.toggle(this.CHECKED_CLASS);

      const allBtn = Array.from(this.DOM.filterButtons).find(
        (b) => b.getAttribute(this.ATTRIBUTE_JOB) === groupJob && b.getAttribute(this.ATTRIBUTE_TAG) === 'all'
      );
      if (allBtn) allBtn.classList.remove(this.CHECKED_CLASS);
    }
  }

  /**
   * 4. 現在チェックされているすべての絞り込み条件を配列で作成・返却
   * @returns {Array} [{ job: 'sales', tags: ['tag1', 'tag2'] }, ...]
   */
  getActiveConditions() {
    const activeConditions = [];
    const checkedButtons = Array.from(this.DOM.filterButtons).filter((b) =>
      b.classList.contains(this.CHECKED_CLASS)
    );

    checkedButtons.forEach((btn) => {
      const job = btn.getAttribute(this.ATTRIBUTE_JOB);
      const tag = btn.getAttribute(this.ATTRIBUTE_TAG);

      let conditionGroup = activeConditions.find((c) => c.job === job);
      if (!conditionGroup) {
        conditionGroup = { job, tags: [] };
        activeConditions.push(conditionGroup);
      }
        conditionGroup.tags.push(tag);
    });

    return activeConditions;
  }

  /**
   * 5. アニメーションを挟んで絞り込みを実行
   * @param {Array} activeConditions 
   */
  applyFilterWithAnimation(activeConditions) {
    this.isAnimating = true;

    // フェードアウト
    if (this.DOM.interviewList) {
      this.DOM.interviewList.classList.add('is-fading');
    }

    setTimeout(() => {
      // 実際に表示／非表示を切り替えるロジックを呼び出し
      this.filterItems(activeConditions);

      // フェードイン
      if (this.DOM.interviewList) {
        this.DOM.interviewList.classList.remove('is-fading');
      }

      setTimeout(() => {
        this.isAnimating = false;
      }, 300);
    }, 200);
  }
/**
   * 6. 条件に合致する要素を表示・非表示にする判定ロジック
   * @param {Array} activeConditions 
   */
  filterItems(activeConditions) {
    // 選択されている条件が一つもない場合（再クリックで全解除された場合）は全件表示
    const isNoFilter = activeConditions.length === 0;

    this.DOM.interviewItems.forEach((card) => {
      const item = card.closest('[data-filter-item-wrap]');
      if (!item) return;

      // フィルター条件が何もなければ全件表示
      if (isNoFilter) {
        item.style.display = 'block';
        return;
      }

      const cardJob = card.getAttribute(this.ATTRIBUTE_JOB);
      const cardTags = (card.getAttribute(this.ATTRIBUTE_TAG) || '').split(' ');

      // OR判定（どれか1つの条件グループに合致すれば表示）
      const isMatch = activeConditions.some((condition) => {
        const isJobMatch = cardJob === condition.job;
        const isTagMatch =
          condition.tags.includes('all') ||
          condition.tags.some((selectedTag) => cardTags.includes(selectedTag));

        return isJobMatch && isTagMatch;
      });

      item.style.display = isMatch ? 'block' : 'none';
    });
  }
}
